import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip, Modal } from 'antd'
import styled from 'styled-components'
import { withApollo } from 'react-apollo';
import RemoveOrderItem from '../../graphql/removeOrderItem';
import { HasPermissions, FlexContainer, ConditionalRender, Text, Loading, Icon, Row, Button } from '../../common';

const ClickableLink = styled.a`
    color: black;
`

const IconContainer = styled.div`
  width: 90px;
  height: 90px;
  background-color: #f38630;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
`

class OrderItemManager extends React.Component {
  state = { visible: false, disabled: true, userSelected: null }

  _toggleModal = () => this.setState({ visible: !this.state.visible })

  _resolveRender = ({ status, wasRemoved, ...data }) => {
    return (
      <HasPermissions to={['order-detail-page:delete-product']}>
        {
          !wasRemoved && (
            <Tooltip placement='left' title={<Text text='order_detail.actions.remove' color='white' />}>
              <ClickableLink onClick={this._toggleModal}>
                <Icon name='trash' color='black' size='11' />
              </ClickableLink>
            </Tooltip>
          )
        }
      </HasPermissions>
    )
  }

  handleOk = () => {
    this.setState({ disabled: false }, () => {
      console.log(this.state)
    })
  }

  refetchQueries = () => {
      setTimeout(() => {
          console.log('refetching order queries RemoveOrderItem');
          this.props.client.reFetchObservableQueries();
      }, 3000);
  };

  handleCancel = () => this._toggleModal()

  _renderModal (data) {
    const { visible, disabled } = this.state
    const { loading, orderId, salesChannelId } = this.props
    const { name = '', sku, id } = data
    // TODO: set default selected value if there is any
    return (
      <Modal
        closable={false}
        title={null}
        visible={visible}
        confirmLoading={loading}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        footer={null}
      >
        <RemoveOrderItem refetchQueries={this.refetchQueries} >
          {({ loading, data, error, updateFn }) => (
            <FlexContainer margin={30} align='center' direction='column'>
              <IconContainer>
                <Icon name='trash' color='#ffffff' size={46.8} />
              </IconContainer>
              <FlexContainer mY={30} direction='column' align='center'>
                <Row justify='center'>
                  <Text text='¿Estas seguro de eliminar&nbsp;' />
                  <Text strong text={`${name}?`} />
                </Row>
                <Row>
                  <Text centered text='Una vez eliminado, no puedes volver atrás.' />
                </Row>
              </FlexContainer>
              <FlexContainer justify='flex-end' style={{ width: '100%' }}>
                <Button link text='btn.action.cancel' style={{ width: 'auto' }} onClick={this.handleCancel} />
                <Button disabled={loading} loading={loading} text='btn.action.delete' style={{ width: 'auto' }} onClick={() => updateFn({ id: orderId, sku: id, salesChannelId }).then(() => this.handleCancel())} />
              </FlexContainer>
            </FlexContainer>
          )}
        </RemoveOrderItem>

      </Modal>
    )
  }

  _defaultRender (data, loading) {
    const { visible } = this.state
    return (
      <Loading loading={loading}>
        {this._resolveRender(data)}
        <ConditionalRender condition={visible}>
          {this._renderModal(data)}
        </ConditionalRender>
      </Loading>
    )
  }
  render () {
    const { renderFn = this._defaultRender.bind(this), data } = this.props
    return renderFn(data, false)
  }
}

OrderItemManager.propTypes = {
  loading: PropTypes.bool,
  renderFn: PropTypes.any,
  client: PropTypes.func
}

export default withApollo(OrderItemManager);
